import { connect } from 'react-redux';
import React from 'react';
import { withRouter } from 'react-router-dom';


import { toggleSpecialistSuggestion } from '../../../actions/searchActions';


const SpecialistBlock = ({ showSpecialistSuggestions, toggleSpecialistSuggestion }) => {
  const handleCheckboxChange = () => {
    toggleSpecialistSuggestion();
  };

  return (
    <div className="specialist-wrapper">
      <div className="text-info">
        <strong>Não sabe qual plano escolher?</strong>
        <span>Nossos especialistas indicam os planos mais completos para sua viagem.</span>
      </div>
      <div className="activate-block">
        <label className="custom-checkbox">
          <input type="checkbox" checked={showSpecialistSuggestions} onChange={handleCheckboxChange} />
          <span className="checkmark"></span>
          Ativar recomendação
        </label>
      </div>
    </div>
  );
};

export default withRouter(
  connect(
    (state) => ({
      showSpecialistSuggestions: state.search.showSpecialistSuggestions,
    }),
    {
      toggleSpecialistSuggestion,
    }
  )(SpecialistBlock)
);



// WEBPACK FOOTER //
// ./src/components/search/plans_table/SpecialistBlock.jsx